import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap, catchError, throwError, Observable, map } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Globals } from './endpoints.global';

@Injectable({
    providedIn: 'root',
})
export class DefaultService {
    httpOptions: HttpHeaders;

    constructor(
        private globals: Globals,
        private http: HttpClient,
        private router: Router,
        private snackBar: MatSnackBar
    ) {
        this.httpOptions = new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }
    getTaxonomyList = () => {
        const endPoint = this.globals.urlJoin('v1', 'taxonomy');
        return this.http
            .get<any>(endPoint, {
                headers: this.httpOptions,
            })
            .pipe(
                tap(res => {
                    console.log(res, 'list of taxonomy');
                    return res;
                }),
                catchError(error => throwError(error))
            );
    };
    getVersionList = (taxonomyId: any): Observable<any> => {
        let endPoint = this.globals.urlJoin('versions', 'versionList');
        endPoint = endPoint.replace(
            'api/v1/taxonomies/versions',
            'api/v1/taxonomies/' + taxonomyId + '/versions'
        );
        console.log(endPoint, 'this is the endpoint for versions');
        return this.http
            .get<any>(endPoint, {
                headers: this.httpOptions,
            })
            .pipe(
                tap(resp => console.log('version list is:', resp)),
                catchError(error => throwError(error))
            );
    };

    getHierarchyList = (taxonomyId: any): Observable<any> => {
        let endPoint = this.globals.urlJoin('hierarchies', 'hierarchyList');
        endPoint = endPoint.replace(
            'api/v1/taxonomies/hierarchies',
            'api/v1/taxonomies/' + taxonomyId + '/hierarchies'
        );
        console.log(endPoint, 'endpoint for hierarchy');
        return this.http
            .get(endPoint, {
                headers: this.httpOptions,
                // params: {
                //   page,
                //   pageSize
                // }
            })
            .pipe(
                map((response: any) => {
                    console.log('hierarchy list is:', response);
                    return response;
                })
                // catchError((error) => throwError(error))
            );
    };
}
